export default function Streaks() {
    return (
        <svg
            aria-hidden
            className="pointer-events-none absolute right-0 top-0 w-[120%] md:w-[80%] h-[700px] -z-0 opacity-90"
            viewBox="0 0 1200 700"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient id="streakA" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#F36C21" stopOpacity="0" />
                    <stop offset="55%" stopColor="#F36C21" stopOpacity="0.55" />
                    <stop offset="100%" stopColor="#FF8A3D" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="streakB" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#FF8A3D" stopOpacity="0" />
                    <stop offset="60%" stopColor="#F36C21" stopOpacity="0.35" />
                    <stop offset="100%" stopColor="#F36C21" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="streakC" x1="0" y1="1" x2="1" y2="0">
                    <stop offset="0%" stopColor="#F36C21" stopOpacity="0" />
                    <stop offset="50%" stopColor="#FF6B1A" stopOpacity="0.45" />
                    <stop offset="100%" stopColor="#F36C21" stopOpacity="0" />
                </linearGradient>
            </defs>

            <path
                d="M 1300 80 Q 900 180 700 260 T 100 480"
                stroke="url(#streakA)"
                strokeWidth="2"
                strokeLinecap="round"
                fill="none"
                strokeDasharray="6 14"
                className="animate-streak-dash"
            />
            <path
                d="M 1300 180 Q 800 240 600 320 T 80 560"
                stroke="url(#streakB)"
                strokeWidth="1.5"
                strokeLinecap="round"
                fill="none"
                strokeDasharray="2 18"
                className="animate-streak-dash"
                style={{ animationDelay: "-2s" }}
            />
            <path
                d="M 1300 360 Q 850 360 650 420 T 60 640"
                stroke="url(#streakC)"
                strokeWidth="2"
                strokeLinecap="round"
                fill="none"
                strokeDasharray="10 22"
                className="animate-streak-dash"
                style={{ animationDelay: "-4s" }}
            />
            <path
                d="M 1300 -20 Q 1000 60 820 130 T 240 360"
                stroke="url(#streakA)"
                strokeWidth="1"
                strokeLinecap="round"
                fill="none"
                strokeDasharray="3 22"
                className="animate-streak-dash"
                style={{ animationDelay: "-3s" }}
            />
        </svg>
    );
}
